import _ from "lodash";
import { getStartEndDatesOfAcademicYears } from "modules/Services";
import { getElementValue } from "modules/ElementValueUtils";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
// This Function is used to extract all the completed or Remaining Element Nodes of a Particular Subject

export const getElementNodes = ({
  elementSet,
  subject,
  isParentTaggingEnabled = false,
}) => {
  const nodesKey = isParentTaggingEnabled ? "nodes" : "plannerElementNode";
  const plannerElementNodes = _.get(elementSet, nodesKey, []);

  return _.filter(plannerElementNodes, node => {
    const associatedSubjectParents = _.filter(
      _.get(node, "associatedParents"),
      parent => _.isEqual(parent["__typename"], "Subject")
    );

    const associatedParentIds = _.map(
      associatedSubjectParents,
      parent => parent.id
    );

    return _.includes(associatedParentIds, subject.id);
  });
};

export const getLeafNodesValueKeys = ({ elementNodes }) => {
  return _.map(
    _.filter(elementNodes, node => node.isLeaf),
    node => node.id
  );
};

export const getElementFilterValue = ({
  fieldUID,
  fieldObj,
  valueKeys,
  valueFilter,
  resolvedValue,
  subjectIds,
  skipRemoveSubjectCheck = false,
  skipMergeStandardsAssociatedParents = false,
}) => {
  const value = getElementValue({
    fieldUID,
    fieldObj,
    valueKeys,
    resolvedValue,
    subjectIds,
    skipRemoveSubjectCheck,
    skipMergeStandardsAssociatedParents,
  });

  return _.filter(value, valueFilter);
};

export const getStringWithArchivedLabel = ({ isArchived, t }) => {
  return isArchived ? ` (${t("common:archived")})` : ``;
};

export const getStaffStudentEntityRosteringStatus = (
  curriculumProgramId,
  curriculumProgramsOfFutureAcademicYear
) => {
  const selectedCurriculumProgram = _.reduce(
    curriculumProgramsOfFutureAcademicYear,
    (result, program) => {
      if (_.get(program, "id", "") === curriculumProgramId) {
        return program;
      }
      return result;
    },
    null
  );

  const isStudentsRosteredForFuture = _.get(
    _.reduce(
      _.get(
        selectedCurriculumProgram,
        "academicYearTransitionConfigurationState",
        []
      ),
      (result, config) => {
        if (_.isEqual(_.get(config, "state", ""), "STUDENT_CONFIGURATION")) {
          return config;
        }
        return result;
      },
      {}
    ),
    "isComplete",
    false
  );

  const isStaffRosteredForFuture = _.get(
    _.reduce(
      _.get(
        selectedCurriculumProgram,
        "academicYearTransitionConfigurationState",
        []
      ),
      (result, config) => {
        if (_.isEqual(_.get(config, "state", ""), "STAFF_CONFIGURATION")) {
          return config;
        }
        return result;
      },
      {}
    ),
    "isComplete",
    false
  );

  return { isStudentsRosteredForFuture, isStaffRosteredForFuture };
};

export const NEW_CONVERSATION = "NEW_CONVERSATION";

//This function returns the start and end Dates of the course
export const getCourseAcademicYearDates = ({ courseId, academicYearId }) => {
  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters: { academicYearId },
  });
  const academicYears = _.get(courseDetails, "academicYears", []);

  return getStartEndDatesOfAcademicYears({ academicYears });
};

export const getCourseAcademicYearDatesMemoize = _.memoize(
  params => getCourseAcademicYearDates(params),
  params => JSON.stringify(params)
);
